'use client';

import { c as _c } from "react/compiler-runtime";
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { DiscountControls, type MentoringDiscountDraft } from '../../../_components/DiscountControls';
import type { MentoringOfferProduct } from '../_helpers/mentoring-terms';
type DiscountPricingSectionProps = {
  mentoringProduct: MentoringOfferProduct;
  discountDraft: MentoringDiscountDraft;
  onDiscountChange: (nextDraft: MentoringDiscountDraft) => void;
  discountInForceDescription: string | null;
};
export function DiscountPricingSection(t0) {
  const $ = _c(9);
  const {
    mentoringProduct,
    discountDraft,
    onDiscountChange,
    discountInForceDescription
  } = t0;
  let t1;
  if ($[0] !== discountInForceDescription) {
    t1 = discountInForceDescription === null ? null : <P3 className="text-contentSecondary">{discountInForceDescription}</P3>;
    $[0] = discountInForceDescription;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== discountDraft || $[3] !== mentoringProduct || $[4] !== onDiscountChange) {
    t2 = <DiscountControls mentoringProduct={mentoringProduct} value={discountDraft} onChange={onDiscountChange} />;
    $[2] = discountDraft;
    $[3] = mentoringProduct;
    $[4] = onDiscountChange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <section className="space-y-3">{t1}{t2}</section>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}